import { render } from "./CIS-ResourceTaxonomies.vue?vue&type=template&id=133d5b2d"
import script from "./CIS-ResourceTaxonomies.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceTaxonomies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__